import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListReferralsV1Query } from './list-referrals-v1-request';
import type { IListReferralsV1Response } from './list-referrals-v1-response';
import { listReferralsV1ResponseSchema } from './list-referrals-v1-response';

export async function listReferralsV1Api(
  query: IListReferralsV1Query = {},
  options?: IRequestOptions,
): Promise<IValidatedResponse<IListReferralsV1Response>> {
  const params = new URLSearchParams();
  if (query.status) {
    params.set('status', query.status);
  }
  if (query.abuseFlag) {
    params.set('abuseFlag', query.abuseFlag);
  }
  if (query.limit !== undefined) {
    params.set('limit', String(query.limit));
  }
  if (query.offset !== undefined) {
    params.set('offset', String(query.offset));
  }
  const qs = params.toString();
  return getRequest<IListReferralsV1Response>({
    path: `/sys/referral/v1/list${qs ? `?${qs}` : ''}`,
    schema: listReferralsV1ResponseSchema,
    options,
  });
}
